import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Button, Row, Col, Form, Checkbox, Input, Modal } from "antd";
import Container from "react-bootstrap/Container";
import BackArrowIcon from "../../assets/images/arrow-back-page.svg";
import ModalSucecesIcon from "../../assets/images/right-check-blue.svg";
import Footer from "../../components/layout/Footer";

const SetupCard = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => setIsModalOpen(true);
    const handleCancel = () => setIsModalOpen(false);

    const handleOk = () => {
        setIsModalOpen(false);
      };

    return (
        
        <div className="col-plan-cards pt-3">
        <Layout className="layout-default layout-signin">
            <Container>
                <div className="back-logo-header" onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                    <img src={BackArrowIcon} alt="Back" />
                </div>
                <Row justify="center">
                    <Col span={24}>
                        <div className="plan-main-headding">
                            <h6 style={{ fontSize: "30px", whiteSpace: "nowrap" }}>Set up your credit or debit card</h6>
                        </div>
                    </Col>

                    <Col span={12} className="payment-setup-card">
                        <Form form={form} layout="vertical">
                            <Form.Item label="Debit/Credit Card">
                                <Input placeholder="Card Number" />
                            </Form.Item>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item>
                                        <Input placeholder="Expiry (MM/YY)" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item>
                                        <Input placeholder="CVV" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item valuePropName="checked">
                                <Checkbox>Save Card?</Checkbox>
                            </Form.Item>
                            <Form.Item>
                                <Button className="modal-fill-btn" type="primary" block onClick={showModal}>
                                    Continue – £12.99 total
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Container>
            {/* <Footer /> */}
        </Layout>
          <Modal
        className="tab_modal"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={415}
        footer={false}
      >
        <div className="modal-inner-body">
          <img className="check-tital-icon" src={ModalSucecesIcon} />
          <h6>You've successfully purchased the Gold Subscription.</h6>
          <p>
            Enjoy exclusive access to premium features and enhanced services.{" "}
          </p>
         <Button className="modal-fill-btn" type="primary" block onClick={() => navigate("/")}>Continue</Button>
        </div>
      </Modal> 
      </div>

    
      
    );
};

export default SetupCard;
